import { createAsyncThunk, createSlice, SerializedError } from '@reduxjs/toolkit';
import axios from 'axios';
import { IMainSubscription } from '../interfaces/mainSubscription';
import { isFetching, error } from './common';
import { CommonRootState } from '../combineReducers';

const name = 'mainSubscription';

export const fetchMainSubscription = createAsyncThunk(
  name,
  async (organizationId: string) => {
    const { data } = await axios.get(`/api/v3.0/organizations/${organizationId}/mainsubscription`);
    return data;
  },
  {
    condition(_, { getState }) {
      const { isFetching, isLoaded } = (getState() as CommonRootState).mainSubscription;
      return !isFetching && !isLoaded;
    }
  }
);

export type State = {
  isFetching: boolean;
  mainSubscription: IMainSubscription;
  isLoaded: boolean;
  error: SerializedError | null;
};

export const initialState: State = {
  isFetching: false,
  mainSubscription: {
    id: '',
    effectiveDate: null,
    expirationDate: null,
    createdDate: null,
    description: '',
    isRenewalAvailable: false,
    isUpgradeAvailable: false,
    previousExpirationDate: null,
    operationType: '',
    countryISO2: '',
    typePublicId: 0
  },
  isLoaded: false,
  error: null
};

const mainSubscription = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchMainSubscription.pending, isFetching);
    builder.addCase(fetchMainSubscription.fulfilled, (state, action) => {
      state.isFetching = false;
      if (action.payload) {
        // Response can be empty with 204 status code
        state.mainSubscription = action.payload;
      }
      state.isLoaded = true;
    });
    builder.addCase(fetchMainSubscription.rejected, error);
  }
});

export const { reducer: mainSubscriptionReducer } = mainSubscription;
